import { useMutation } from "@tanstack/react-query";
import {
  groupAdd,
  GroupAddParams,
} from "common/api/citajteo/dl_group/citajteo_group";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseGroupAddParams = {
  invalidateKeys?: string[];
  successHandle?: Function;
  errorHandle?: Function;
};

export const useGroupAdd = (hookParams?: UseGroupAddParams) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: groupAddMutate } = useMutation({
    mutationFn: async (groupAddParams: GroupAddParams) => {
      const response = await groupAdd(groupAddParams);

      if (response === null) {
        throw new Error("groupAdd failed");
      }

      return response;
    },
    onSuccess: (response) => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }

      if (hookParams?.successHandle) {
        hookParams.successHandle(response);
      }
    },
    onError: (error) => {
      if (hookParams?.errorHandle) {
        hookParams.errorHandle(error);
      }
    },
  });

  return { groupAddMutate };
};
